import {Component, OnInit, Optional} from '@angular/core';
import { Router } from '@angular/router';
import {ClientITProfile, Project, User} from '../../_models';
import {
  AlertService,
  AuthenticationService, ClientProfileService,
  ProjectService,
} from '../../_services';
import { LoginHelper, Recurring, StringsHelper } from '../../helpers';
import {DynamicDialogRef} from "primeng/dynamicdialog";
import {EvidenceCentralItem} from "../../_models/evidenceCentralItem";
import {EvidenceCentralService} from "../../_services/evidenceCentral.service";
import {MatDialogRef} from "@angular/material/dialog";

@Component({
    standalone: false,
  selector: 'select-evidenceCentralItem',
  templateUrl: 'select-evidenceCentralItem.component.html',
  styleUrls: ['./select-evidenceCentralItem.component.scss'],
})
export class SelectEvidenceCentralItemComponent implements OnInit {
  evidenceCentralItems: EvidenceCentralItem[] = [];
  currentUser: User;

  cols: any[] = [
    { 'field': 'controlItem.name', 'header': 'Control ID' },
  ];

  constructor(
    public evidenceCentralService: EvidenceCentralService,
    public router: Router,
    public authenticationService: AuthenticationService,
    public alertService: AlertService,
    public dialogRef: MatDialogRef<SelectEvidenceCentralItemComponent>,
  ) {}

  ngOnInit() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }
    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));

    this.evidenceCentralService.getAll().subscribe(
      (evidenceCentralItems) => {
        this.evidenceCentralItems = evidenceCentralItems;
      },

      (error) => {
        const errorMessage = 'An error occurred while loading profiles.';
        this.alertService.error(errorMessage);
      }
    );
  }

  getFullName(user: User) {
    return StringsHelper.getFullName(user);
  }

  selectDevice(data) {
    data.clientITProfileName = this.evidenceCentralItems.find(
      (p) => p.id == data.id
    ).name;
    this.dialogRef.close(data);
  }
}
